import { getEnabled } from '../actions/feature_flags'
 
export const fetchGetFeatureFlags = (dispatch:any) =>
  (key:any, featureName:string, { site, userId }:{site:string, userId: string}) =>
    dispatch(getEnabled(featureName, site, userId));

